module.exports = __webpack_public_path__ + "img/catalina-front-angle.c1d49cdd.png";